import { render, staticRenderFns } from "./ChangeBlockDocuments.vue?vue&type=template&id=32913f5a&scoped=true"
import script from "./ChangeBlockDocuments.vue?vue&type=script&lang=js"
export * from "./ChangeBlockDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32913f5a",
  null
  
)

export default component.exports